import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserService } from '@everysens/frontend-shared-v2';
import { environment } from '@rtls-environment/environment';
import { CabaneService } from '@rtls/core/cabane/cabane.service';

export const canAccessRailwatch = () => {
	const cabane = inject(CabaneService);
	const userService = inject(UserService);

	console.log('cabane: ', cabane.hasRailwatchEnabled());
	console.log('permission: ', userService.checkIfUserHasAllPermissions('read:railwatch.app'));

	return cabane.hasRailwatchEnabled() && userService.checkIfUserHasAllPermissions('read:railwatch.app');
};

@Component({
	selector: 'app-railwatch',
	template: `<iframe [src]="iframeURL" class="h-full w-full border-none"></iframe>`,
	host: { class: 'block h-full overflow-hidden' },
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RailwatchComponent {
	private readonly sanitizer = inject(DomSanitizer);
	private readonly router = inject(Router);
	private readonly cabane = inject(CabaneService);
	private readonly userService = inject(UserService);

	protected readonly iframeURL = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.baseURL}/railwatch/`);

	constructor() {
		const hasRailwatchConfig = this.cabane.hasRailwatchEnabled();
		const hasRailwatchPermission = this.userService.checkIfUserHasAllPermissions('read:railwatch.app');

		if (hasRailwatchConfig && hasRailwatchPermission) return;

		this.router.navigate(['/']);
	}
}
